var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { withTranslation } from 'react-i18next';
import AccountNavigation from '../modules/Account/partials/AccountNavigation';
import SimpleHeader from '../layouts/partials/SimpleHeader';
import { localizeUrl } from '../core/helpers/url-helper';
import PageHeaderBlock from '../components/PageHeaderBlock';
var AccountPage = /** @class */ (function (_super) {
    __extends(AccountPage, _super);
    function AccountPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountPage.prototype.render = function () {
        return (React.createElement("div", { className: "p-account" },
            React.createElement("div", { className: "p-account__header" },
                React.createElement("div", { className: "p-account__header__simple" },
                    React.createElement(SimpleHeader, { title: this.props.t(this.props.title), backUrl: localizeUrl("/cart") })),
                React.createElement("div", { className: "p-account__header__desktop" },
                    React.createElement(PageHeaderBlock, { title: this.props.title }))),
            React.createElement("div", { className: "p-account__content" },
                React.createElement("div", { className: "p-account__content__navigation" },
                    React.createElement(AccountNavigation, null)),
                React.createElement("div", { className: "p-account__content__right" }, this.props.children)),
            React.createElement("div", { className: "h-padding-y--30" })));
    };
    return AccountPage;
}(React.Component));
export default withTranslation()(AccountPage);
